<mat-icon class="del" [matMenuTriggerFor]="delMenu"> more_vert</mat-icon>
<mat-menu #delMenu="matMenu">
  <button mat-menu-item (click)="delete()"><mat-icon>delete</mat-icon>Delete</button>
</mat-menu>
